// Common server names per broker / platform / account type. Used to populate
// the Server field's <datalist> on the Brokers page — user can still type any
// custom server, but this gives them a one-click pick for the usual ones.
//
// Source: vendor docs (Exness MyAccount, FBS Trader Cabinet, etc.) as of Q1 2026.
// Keep this file lightweight — no API call needed.
export const BROKER_SERVERS = {
  Exness: {
    mt5: {
      demo: [
        "Exness-MT5Trial", "Exness-MT5Trial2", "Exness-MT5Trial3", "Exness-MT5Trial4",
        "Exness-MT5Trial5", "Exness-MT5Trial6", "Exness-MT5Trial7", "Exness-MT5Trial8",
        "Exness-MT5Trial9", "Exness-MT5Trial10", "Exness-MT5Trial11", "Exness-MT5Trial12",
        "Exness-MT5Trial13", "Exness-MT5Trial14",
      ],
      real: [
        "Exness-MT5Real", "Exness-MT5Real2", "Exness-MT5Real3", "Exness-MT5Real4",
        "Exness-MT5Real5", "Exness-MT5Real6", "Exness-MT5Real7", "Exness-MT5Real8",
        "Exness-MT5Real9", "Exness-MT5Real10", "Exness-MT5Real11", "Exness-MT5Real12",
        "Exness-MT5Real13", "Exness-MT5Real14", "Exness-MT5Real15", "Exness-MT5Real16",
        "Exness-MT5Real17", "Exness-MT5Real18", "Exness-MT5Real19", "Exness-MT5Real20",
        "Exness-MT5Real21", "Exness-MT5Real22", "Exness-MT5Real23", "Exness-MT5Real24",
        "Exness-MT5Real25", "Exness-MT5Real26", "Exness-MT5Real27", "Exness-MT5Real28",
        "Exness-MT5Real29", "Exness-MT5Real30", "Exness-MT5Real31", "Exness-MT5Real32",
      ],
    },
    mt4: {
      demo: ["Exness-Trial", "Exness-Trial2", "Exness-Trial3", "Exness-Trial4", "Exness-Trial5"],
      real: [
        "Exness-Real", "Exness-Real2", "Exness-Real3", "Exness-Real4", "Exness-Real5",
        "Exness-Real6", "Exness-Real7", "Exness-Real8", "Exness-Real9", "Exness-Real10",
        "Exness-Real11", "Exness-Real12", "Exness-Real13", "Exness-Real14", "Exness-Real15",
      ],
    },
  },
  FBS: {
    mt5: {
      demo: ["FBS-Demo"],
      real: ["FBS-Real", "FBS-Real-2", "FBS-Real-3", "FBS-Real-4", "FBS-Real-5"],
    },
    mt4: {
      demo: ["FBS-Demo"],
      real: ["FBS-Real", "FBS-Real-2", "FBS-Real-3", "FBS-Real-4"],
    },
  },
};

export function getServerSuggestions(broker, platform, accountType) {
  const b = BROKER_SERVERS[broker];
  if (!b) return [];
  const p = b[platform];
  if (!p) return [];
  return p[accountType] || [];
}
